var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09346 9.31215L9.38542 13.2625C9.70526 13.6463 10.2947 13.6463 10.6146 13.2625L13.9065 9.31215C14.3408 8.79109 13.9702 8 13.292 8L6.70803 8C6.02976 8 5.65924 8.79109 6.09346 9.31215Z",
    fill: "#014780"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 20C2.23858 20 -7.76377e-07 17.7614 -6.55671e-07 15L-2.18557e-07 5C-9.78512e-08 2.23857 2.23858 -7.76376e-07 5 -6.55671e-07L15 -2.18557e-07C17.7614 2.26487e-06 20 2.23858 20 5L20 15C20 17.7614 17.7614 20 15 20L5 20ZM0.999999 15L1 5C1 2.79086 2.79086 0.999998 5 0.999999L15 1C17.2091 1 19 2.79086 19 5L19 15C19 17.2091 17.2091 19 15 19L5 19C2.79086 19 0.999999 17.2091 0.999999 15Z",
    fill: "#014780"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.8c9b286e.svg";
export { ForwardRef as ReactComponent };